import { render } from "./ArrowLeft.vue?vue&type=template&id=160a96c0"
const script = {}
script.render = render

export default script